import React from 'react';
import { Message } from 'semantic-ui-react';
import McpAccessPanel from '~/features/admin/McpAccess/McpAccessPanel';
import { useUserContext } from '~/hooks';

export default function AdminMcpAccess() {
  const { loggedInUser } = useUserContext();

  if (!loggedInUser?.isAdmin) {
    return <Message negative>Only admin users can manage MCP access.</Message>;
  }

  return (
    <div style={{ padding: '2rem', maxWidth: '60rem' }}>
      <h1>Claude MCP access</h1>
      <McpAccessPanel />
    </div>
  );
}
